import MultiSelectDropdown from "../dropdowns/multiSelectDropdown";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_PRELOAD_SIZE } from "../../utils/constants";
import useApiClient from "../../hooks/useApiClient";
import { useState } from "react";
import { useDebouncedFunction } from "../../hooks/useDebouncedQueryParams";
import { DEBOUNCE_DELAY } from "../../utils";
import { MultiSelectDropdownSmartWrapperProps } from "../dropdowns/types";
import { QUERY_OPTIONS_LOAD_ONCE } from "../../apiUtils";
import { titleCase } from "../../utils";



interface SealogEventFreeTextDropdownProps {
    dropdownProps: MultiSelectDropdownSmartWrapperProps<string, string>;
    apiOptions: {
        eventValue?: string[],
        eventOptionNames?: string[],
        eventOptionValues?: string[],
        hasDataAsset?: boolean,
    };
}


export const SealogEventFreeTextDropdown = ({
    apiOptions,
    dropdownProps,
}: SealogEventFreeTextDropdownProps) => {
    const api = useApiClient();
    const [debouncedSearchTerm, _setDebounceSearchTerm] = useState("");
    const setDebounceSearchTerm = useDebouncedFunction(
        _setDebounceSearchTerm,
        DEBOUNCE_DELAY
    );

    const mergedApiOptions = {
        size: DROPDOWN_PRELOAD_SIZE,
        query: debouncedSearchTerm || undefined,
        ...apiOptions
    }


    const { data: sealogEventFreeTexts, isLoading: sealogEventFreeTextsAreLoading } = useQuery({
        queryKey: ["sealogEventFreeTexts", Object.entries(mergedApiOptions)],
        queryFn: async () => {
            const freeTexts = await api.sealog.listUniqueSealogEventFreeTexts({
                ...mergedApiOptions
            });
            return freeTexts.items;
        },
        ...QUERY_OPTIONS_LOAD_ONCE,
        enabled: !dropdownProps.isLoading,
    });

    return (
        <MultiSelectDropdown<string, string>
            label={"Event Description"}
            options={sealogEventFreeTexts ?? []}
            selections={[]}
            isLoading={dropdownProps.isLoading || sealogEventFreeTextsAreLoading}
            renderOption={(o) => titleCase(o)}
            onSearchTermChange={setDebounceSearchTerm}
            mapOptionToSelection={o => o}
            {...dropdownProps}
        />
    )
}